import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { DropdownProperties } from '../Dropdown';

type Item = Items[number];
type Items = NonNullable<NonNullable<DropdownProperties['menu']>['items']>;

type P = {
  items?: Items;
};

export const useTranslateDropdownMenuItems = ({ items }: P): Items | undefined => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!items) {
      return undefined;
    }

    const translateItems = (menuItems: Items): Items =>
      menuItems.map((item): Item => {
        if (!item || item.type === 'divider') {
          return item;
        }

        if ('children' in item && Array.isArray(item.children)) {
          return {
            ...item,
            ...('label' in item && typeof item.label === 'string' ? { label: t(item.label) } : {}),
            children: translateItems(item.children),
          };
        }

        if ('label' in item && typeof item.label === 'string') {
          return { ...item, label: t(item.label) };
        }

        return item;
      });

    return translateItems(items);
  }, [items, t]);
};
